/* eslint-disable */
export default {
  // inventoryListing should match mediaViewerSm so we can reuse common sizes on SRP and VDP
  inventoryListing: {
    width: 408,
    height: 306
  },
  // Desktop viewport
  inventoryListingLg: {
    width: 304,
    height: 228
  },
  inventoryListingMd: {
    width: 236,
    height: 177
  },
  // Tablet viewport
  inventoryListingSm: {
    width: 236,
    height: 177
  },
  inventoryCard: {
    width: 283,
    height: 177
  },
  inventoryThumb: {
    width: 72,
    height: 54
  },
  ownerDetails: {
    width: 544,
    height: 408
  },
  inventoryCarousel: {
    width: 213,
    height: 160
  },
  inventoryCarouselSm: {
    width: 280,
    height: 157
  },
  inventoryCarouselLg: {
    width: 280,
    height: 157
  },
  inventoryThumbxLg: {
    width: 147,
    height: 108
  },
  inventoryThumbLg: {
    width: 104,
    height: 100
  },
  inventoryThumbSm: {
    width: 64,
    height: 78
  },
  mediaViewerxLg: {
    width: 800,
    height: 600
  },
  mediaViewerSm: {
    width: 408,
    height: 306
  },
  //Image sizes for NewsReviews
  newsReviewsFeatureImgLg: {
    width: 520,
    height: 345
  },
  newsReviewsFeatureImgMd: {
    width: 405,
    height: 270
  },
  newsReviewsFeatureImgSm: {
    width: 361,
    height: 240
  },
  newsReviewsFeatureImgXs: {
    width: 130,
    height: 85
  },
  newsReviewsSubImgLg: {
    width: 248,
    height: 165
  },
  newsReviewsSubImgMd: {
    width: 190,
    height: 128
  },
  newsReviewsSubImgSm: {
    width: 168,
    height: 112
  },
  newsReviewsSubImgXs: {
    width: 130,
    height: 85
  },
  // openGraph image
  openGraphImg: {
    width: 1200,
    height: 630
  }
};